import Breadcrumbs from "@/components/Breadcrumbs";
import { SettingsService } from "@/services/admin-services";
import { Software } from "@/services/global-services/models";
import {
    Box,
    Button,
    CircularProgress,
    Divider,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import clsx from "clsx";
import { sortBy } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const breadcrumbs = [
    {
        to: "../..",
        title: "Administration",
    },
    {
        title: "Settings",
        to: "../..",
    },
    {
        title: "BIMQ Parameters",
        to: "",
    },
];

const Overview = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [data, setData] = useState<Array<Software>>([]);

    const settingsService = new SettingsService("int");

    const navigate = useNavigate();

    useEffect(() => {
        settingsService.getBimqParameters().then((data) => {
            setData(data.filter((x) => x.type !== "DataStructure"));
            setIsLoading(false);
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderStatus = (active: boolean, labels: { true: string; false: string }) => {
        return (
            <span
                className={clsx([
                    "inline-flex items-center rounded-full px-2 py-1 text-xs font-medium",
                    active ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700",
                ])}
            >
                {active ? labels.true : labels.false}
            </span>
        );
    };

    return (
        <Box>
            <Breadcrumbs trail={breadcrumbs} />

            <Divider />

            <Grid container spacing={2} p={{ xs: 2, md: 4 }}>
                <Grid size={{ xs: 12, md: 12 }}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 750 }} aria-label="simple table">
                            <TableHead sx={{ bgcolor: "alternate.main" }}>
                                <TableRow>
                                    <TableCell>
                                        <Typography
                                            color={"text.secondary"}
                                            variant={"caption"}
                                            fontWeight={700}
                                            sx={{ textTransform: "uppercase" }}
                                        >
                                            BIMQ Parameter
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            color={"text.secondary"}
                                            variant={"caption"}
                                            fontWeight={700}
                                            sx={{ textTransform: "uppercase" }}
                                        >
                                            Label
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            color={"text.secondary"}
                                            variant={"caption"}
                                            fontWeight={700}
                                            sx={{ textTransform: "uppercase" }}
                                        >
                                            Type
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            color={"text.secondary"}
                                            variant={"caption"}
                                            fontWeight={700}
                                            sx={{ textTransform: "uppercase" }}
                                        >
                                            Used as classification?
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ width: 100 }}>
                                        <Typography
                                            color={"text.secondary"}
                                            variant={"caption"}
                                            fontWeight={700}
                                            sx={{ textTransform: "uppercase" }}
                                        >
                                            Status
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ width: 100 }} />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {isLoading ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={5}
                                            sx={{
                                                height: 400,
                                                alignItems: "center",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <Box sx={{ display: "flex", placeContent: "center" }}>
                                                <CircularProgress />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    sortBy(data, ["type", "order", "name", "bimQLabel"]).map((item, i) => (
                                        <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                            <TableCell component="th" scope="row">
                                                <Typography color={"text.secondary"} variant={"subtitle2"}>
                                                    {item.bimQLabel}
                                                </Typography>
                                            </TableCell>
                                            <TableCell scope="row">
                                                <Typography color={"text.secondary"} variant={"subtitle2"}>
                                                    {item.name}
                                                </Typography>
                                            </TableCell>
                                            <TableCell scope="row">
                                                <Typography color={"text.secondary"} variant={"subtitle2"}>
                                                    {item.type}
                                                </Typography>
                                            </TableCell>
                                            <TableCell scope="row">
                                                <Typography color={"text.secondary"} variant={"subtitle2"}>
                                                    {renderStatus(item.isClassification || false, {
                                                        true: "Yes",
                                                        false: "No",
                                                    })}
                                                </Typography>
                                            </TableCell>
                                            <TableCell scope="row">
                                                <Typography color={"text.secondary"} variant={"subtitle2"}>
                                                    {renderStatus(item.active, {
                                                        true: "Active",
                                                        false: "Inactive",
                                                    })}
                                                </Typography>
                                            </TableCell>
                                            <TableCell scope="row" sx={{ p: 0 }}>
                                                <Box sx={{ display: "flex" }}>
                                                    <Button
                                                        color={"primary"}
                                                        sx={{ ml: "auto", mr: 1 }}
                                                        onClick={() =>
                                                            navigate(`/admin/settings/bimq-parameters/${item.id}`)
                                                        }
                                                    >
                                                        View
                                                    </Button>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Overview;
